export default __webpack_public_path__ + "static/media/vox-img-legacy-012.ebfd1ba8.jpg";